var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"transform":_vm.toPosition}},[_c('rect',{staticClass:"item",attrs:{"width":_vm.item.w,"height":_vm.item.h,"filter":"url(#drop-shadow)"},on:{"pointerdown":function($event){_vm.startDrag($event)},"dblclick":_vm.openEditor}}),_vm._v(" "),_c('foreignObject',{attrs:{"width":"300","height":"300","x":"0","y":"0"}},[_c('div',{staticClass:"innerText",domProps:{"textContent":_vm._s(_vm.item.text)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5499e54","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/FusenGroup.vue
// module id = 17
// module chunks = 0